import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import useAdminsApi from '../api/useAdminsApi';
import { toast } from 'react-toastify';
import CommonLoader from '../components/loaders/CommonLoader';
import { useAuth } from '../contexts/AuthContext';

const ViewProfileLayer = () => {
    const { setProfile } = useAuth();
    const [imagePreview, setImagePreview] = useState('assets/images/user-grid/user-grid-img13.png');
    const [data, setData] = useState({});
    const [form, setForm] = useState({
        user_name: '',
        phone_number: '',
        profile_photo: ''
    });

    const { getProfile, updateProfile, loading } = useAdminsApi();

    const fetchProfile = async () => {
        try {
            const res = await getProfile();
            const profile1 = res.data.payload?.find_user;
            setProfile(profile1)
            setData(profile1);
            setImagePreview(profile1.profile_photo || imagePreview);
            setForm({
                user_name: profile1.user_name || '',
                phone_number: profile1.phone_number || '',
                profile_photo: profile1.user_id?.profile_photo || ''
            });
        } catch (err) {
            console.error('Failed to fetch profile:', err);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    const readURL = (input) => {
        if (input.target.files && input.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagePreview(e.target.result);
                setForm(prev => ({ ...prev, profile_photo: e.target.result }));
            };
            reader.readAsDataURL(input.target.files[0]);
        }
    };

    const handleSave = async () => {
        try {
            const payload = {
                user_name: form.user_name,
                phone_number: form.phone_number,
                profile_photo: form.profile_photo
            };
            await updateProfile(payload);
            toast.success('Profile updated successfully');
            fetchProfile();
        } catch (err) {
            toast.error('Failed to update profile');
            console.error(err);
        }
    };

    return (
        <>
            {loading ? <CommonLoader /> :
                <div className="row gy-4">
                    <div className="col-lg-4">
                        <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
                            <div className="pb-24 ms-16 mb-24 me-16  mt-16">
                                <div className="text-center border border-top-0 border-start-0 border-end-0">
                                    <img
                                        src={imagePreview}
                                        alt=""
                                        className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
                                    />
                                    <h6 className="mb-0 mt-16">{data.user_name}</h6>
                                    <span className="text-secondary-light mb-16">{data.email}</span>
                                </div>
                                <div className="mt-24">
                                    <h6 className="text-xl mb-16">Personal Info</h6>
                                    <ul>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Full Name</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {data.user_name}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Email</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {data.email}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Phone Number</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {data.phone_number}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Role</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {data?.user_type}</span>
                                        </li>
                                        {/* {data.walletId && (
                                            <>
                                                <li className="d-flex align-items-center gap-1 mb-12">
                                                    <span className="w-30 text-md fw-semibold text-primary-light">Type</span>
                                                    <span className="w-70 text-secondary-light fw-medium">: {data.walletId.salaryBaseInfo?.salaryType || "-"}</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-1 mb-12">
                                                    <span className="w-30 text-md fw-semibold text-primary-light">Wallet</span>
                                                    <span className="w-70 text-secondary-light fw-medium">: {data.walletId.totalBalance || 0}</span>
                                                </li>
                                            </>
                                        )} */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="card h-100">
                            <div className="card-body p-24">
                                <h6 className="text-md text-primary-light mb-16">Edit Profile</h6>
                                <div className="mb-24 mt-16">
                                    <div className="avatar-upload">
                                        <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                                            <input
                                                type="file"
                                                id="imageUpload"
                                                accept=".png, .jpg, .jpeg"
                                                hidden
                                                onChange={readURL}
                                            />
                                            <label
                                                htmlFor="imageUpload"
                                                className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                                            >
                                                <Icon icon="solar:camera-outline" className="icon"></Icon>
                                            </label>
                                        </div>
                                        <div className="avatar-preview">
                                            <div
                                                id="imagePreview"
                                                style={{
                                                    backgroundImage: `url(${imagePreview})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                                <label htmlFor="name" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                                    Full Name<span className="text-danger-600">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control radius-8"
                                                    id="name"
                                                    value={form.user_name}
                                                    onChange={(e) => setForm(prev => ({ ...prev, user_name: e.target.value }))}
                                                    placeholder="Enter Full Name"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                                <label htmlFor="email" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                                    Email
                                                </label>
                                                <input
                                                    type="email"
                                                    disabled={data?.user_type?.toLowerCase() !== 'superadmin'}
                                                    className="form-control radius-8"
                                                    id="email"
                                                    value={data.email}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                                <label htmlFor="number" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                                    Phone
                                                </label>
                                                <input
                                                    type="text"
                                                    disabled={data?.user_type?.toLowerCase() !== 'superadmin'}
                                                    maxLength={10}
                                                    className="form-control radius-8"
                                                    id="number"
                                                    value={form.phone_number}
                                                    onChange={(e) => setForm(prev => ({ ...prev, phone_number: e.target.value }))}
                                                    placeholder="Enter phone number"
                                                />
                                            </div>
                                        </div>
                                        {/* {data?.user_type?.toLowerCase() !== 'superadmin' &&
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label htmlFor="depart" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                                        Type
                                                    </label>
                                                    <select
                                                        disabled={data?.user_type?.toLowerCase() !== 'superadmin'}
                                                        className="form-control radius-8 form-select"
                                                        id="depart"
                                                        value={form.salaryType}
                                                        onChange={(e) => setForm(prev => ({ ...prev, salaryType: e.target.value }))}
                                                    >
                                                        <option value="">Select salary type</option>
                                                        <option value="fixed">Fixed</option>
                                                        <option value="incentive">Incentive</option>
                                                        <option value="fixed_plus_incentive">Fixed Plus Incentive</option>
                                                    </select>
                                                </div>
                                            </div>
                                        } */}
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <button
                                            type="submit"
                                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default ViewProfileLayer;